import React from 'react';
import { getUserRoleColor } from '@/components/ui/styles/adminHelpers';

interface RoleBadgeProps {
  role: string;
  className?: string;
}

/**
 * RoleBadge - Reusable role badge component
 * 
 * Displays user roles with appropriate color coding using the
 * getUserRoleColor utility function for consistent styling.
 */
const RoleBadge: React.FC<RoleBadgeProps> = ({
  role,
  className = ''
}) => {
  // Display role mapping for better readability
  const displayRole = role === 'content_creator' ? 'CREATOR' : role.replace('_', ' ').toUpperCase();
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getUserRoleColor(role)} ${className}`}>
      {displayRole}
    </span>
  );
};

export default RoleBadge;
